// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table_tableWrapper__5lshx","table":"table_table__gkJJx"};